export const getAttendeeGenderOptions = () =>
  [
    { value: 'male', label: I18n.t('react.shared.personalisation.gender.male') },
    { value: 'female', label: I18n.t('react.shared.personalisation.gender.female') },
    { value: 'other', label: I18n.t('react.shared.personalisation.gender.other') },
    { value: 'prefer_not_to_say', label: I18n.t('react.shared.personalisation.gender.prefer_not_to_say') },
  ] as const

export const getAttendeeColumnLabels = () => ({
  attendee_company: I18n.t('react.shared.personalisation.attendee_company'),
  attendee_job_title: I18n.t('react.shared.personalisation.attendee_job_title'),
  attendee_gender: I18n.t('react.shared.personalisation.attendee_gender'),
  attendee_date_of_birth: I18n.t('react.shared.personalisation.attendee_date_of_birth'),
})

export const ATTENDEE_EXTRA_CONFIG_KEYS = ['company', 'role', 'gender', 'dateOfBirth'] as const

export const omitAttendeeExtraFields = <T>(fields: Record<string, T> | undefined | null): Record<string, T> =>
  Object.fromEntries(
    Object.entries(fields || {}).filter(([key]) => !(ATTENDEE_EXTRA_CONFIG_KEYS as readonly string[]).includes(key))
  )

// Omitted `fields` keeps the old always-on render so an old payload does not hide every extra input.
// ISS-025: the map covers every field the manage-page Edit attendee modal renders, not only the
// extras, because the template gates all of them. Names match what the backend emits from
// PersonalisationFields::ATTRIBUTE_FOR_CONFIG_KEY; the camelCase twins tolerate a camelised payload.
const EXTRA_FIELD_NAMES: Record<string, string[]> = {
  salutation: ['salutation'],
  firstName: ['first_name', 'firstName'],
  lastName: ['last_name', 'lastName'],
  // No `email`: the manage-page window always renders it, so a gate key would only invite one.
  phone: ['phone'],
  street: ['street'],
  streetNumber: ['street_number', 'streetNumber'],
  zip: ['zip'],
  city: ['city'],
  country: ['country_code', 'countryCode'],
  company: ['company'],
  jobTitle: ['job_title', 'jobTitle'],
  gender: ['gender'],
  dateOfBirth: ['date_of_birth', 'dateOfBirth'],
}

export const extraFieldVisible = (
  fields: Array<{ name?: string; required?: boolean }> | undefined | null,
  key: keyof typeof EXTRA_FIELD_NAMES
): boolean => {
  if (!fields) return true
  const names = EXTRA_FIELD_NAMES[key]
  return fields.some((field) => field?.name && names.includes(field.name))
}

export const extraFieldRequired = (
  fields: Array<{ name?: string; required?: boolean }> | undefined | null,
  key: keyof typeof EXTRA_FIELD_NAMES
): boolean => {
  if (!fields) return false
  const names = EXTRA_FIELD_NAMES[key]
  return fields.some((field) => field?.name && names.includes(field.name) && Boolean(field.required))
}
